export default {
  ru: {
    pages: {
      profile: 'Профиль',
      employees: 'Сотрудники',
      generalPage: 'Общая страница',
      tipAnalytics: 'Аналитика чаевых',
      newBranch: 'Новое заведение',
      qrCode: 'QR-код',
      myTips: 'Мои чаевые',
      myCompany: 'Мое заведение'
    },
    navigation: {
      user: 'Пользователь',
      userAccount: 'Личный кабинет Контура',
      logOut: 'Выйти'
    },
    a11y: {
      goToHomePage: 'Действие: перейти на главную',
      skipToMainContent: 'Действие: пропустить меню',
      openDropdown: 'Действие: открыть меню',
      closeDropdown: 'Действие: закрыть меню'
    },
    form: {
      companyName: 'Название заведения',
      companyАddress: 'Адрес заведения',
      companyType: 'Тип заведения'
    }
  }
}
